export const alignments = {
	vertical: {
		label: 'Vertical',
		value: 'vertical',
	},
	horizontal: {
		label: 'Horizontal',
		value: 'horizontal',
	},
};

export const optionLabelPositions = {
	top: {
		label: 'Top',
		value: 'top',
	},
	bottom: {
		label: 'Bottom',
		value: 'bottom',
	},
	left: {
		label: 'Left',
		value: 'start',
	},
	right: {
		label: 'Right',
		value: 'end',
	},
};
